import { NgModule } from '@angular/core'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { Routes, RouterModule } from '@angular/router'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedModule } from 'src/app/shared.module'
import { LayoutsModule } from 'src/app/layouts/layouts.module'
import { AppPreloader } from 'src/app/app-routing-loader'
import { AuthGuard } from 'src/app/guards/auth.guard'

// layouts & notfound
import { LayoutAuthComponent } from 'src/app/layouts/Auth/auth.component'
import { LayoutMainComponent } from 'src/app/layouts/Main/main.component'
import { Error404Component } from 'src/app/pages/auth/404/404.component'
import { SpasInterceptor } from './pages/spas/spas.interceptor'
import { ReaderInterceptor } from "./pages/spas/reader.interceptor"

const COMPONENTS: any[] = [Error404Component]

const routes: Routes = [
  {
    path: '',
    redirectTo: 'spas/dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutMainComponent,
    children: [
      {
        path: 'spas',
        canActivate: [AuthGuard],
        loadChildren: () => import('src/app/pages/spas/spas.module').then(m => m.SpasModule),
      },
    ],
  },
  {
    path: '',
    component: LayoutMainComponent,
    children: [
      {
        path: 'user',
        canActivate: [AuthGuard],
        loadChildren: () => import('src/app/pages/user/user.module').then(m => m.UserModule),
      },
    ],
  },
  {
    path: 'auth',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/pages/auth/auth.module').then(m => m.AuthModule),
      },
    ],
  },
  {
    path: '**',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        component: Error404Component,
        canActivate: [AuthGuard],
        data: { title: 'Not Found' },
      },
    ],
  },
]

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    // RouterModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: AppPreloader,
    }),
    LayoutsModule,
  ],
  providers: [
    AppPreloader,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ReaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpasInterceptor,
      multi: true,
    },
  ],
  declarations: [...COMPONENTS],
  exports: [RouterModule],
})
export class AppRoutingModule {}
